import Vue from 'vue'
import vuetify from './vuetify'
import store from '../store'
import axios from './axios'
import { i18n } from './i18n'

import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

const context = {
  store,
  vuetify,
  axios,
  i18n
}

Vue.use(VuetifyDialog, {
  context,
  notification: {
    position: 'top-right',
  },
})
